// extracted by mini-css-extract-plugin
export default {"wrapper":"LowerFilters_wrapper__dvAZX","name":"LowerFilters_name__mc7OE"};